export default class Countdown {

	endDate = null;
	finishText = null;

	elements = {
		days: null,
		hours: null,
		minutes: null,
		seconds: null,
		time: null,
	};

	options = {
		text: {
			day1: 'den',
			day2: 'dny',
			day3: 'dní',
		}
	};

	/**
	 *
	 * @param {Element} block
	 * @param {{}} options
	 */
	constructor(block, options = {}) {
		this.options = Object.assign(this.options, options);

		const endDate = block.getAttribute('data-countdown');
		this.endDate = new Date(endDate).getTime();

		if (isNaN(this.endDate)) {
			console.error('Invalid date');
			return;
		}

		this.finishText = block.getAttribute('data-countdown-finish-text');

		this.elements.days = block.querySelector('[data-countdown-days]');
		this.elements.hours = block.querySelector('[data-countdown-hours]');
		this.elements.minutes = block.querySelector('[data-countdown-minutes]');
		this.elements.seconds = block.querySelector('[data-countdown-seconds]');
		this.elements.time = block;

		setInterval(this.calculate.bind(this), 1000);

		block.Countdown = this;
	}

	calculate() {
		let startDate = new Date().getTime();

		let timeRemaining = parseInt((this.endDate - startDate) / 1000);

		if (timeRemaining >= 0) {
			let days = parseInt(timeRemaining / 86400);
			timeRemaining = (timeRemaining % 86400);

			let hours = parseInt(timeRemaining / 3600);
			hours = hours < 10 ? "0" + hours : hours;
			timeRemaining = (timeRemaining % 3600);

			let minutes = parseInt(timeRemaining / 60);
			minutes = minutes < 10 ? "0" + minutes : minutes;
			timeRemaining = (timeRemaining % 60);

			let seconds = parseInt(timeRemaining);
			seconds = seconds < 10 ? "0" + seconds : seconds;

			if (this.elements.days && this.elements.hours && this.elements.minutes && this.elements.seconds) {
				this.elements.days.innerHTML = days;
				this.elements.hours.innerHTML = hours;
				this.elements.minutes.innerHTML = minutes;
				this.elements.seconds.innerHTML = seconds;
			} else {
				let time = '';
				if (days > 0) {
					time = days + ' ' + (days < 2 ? this.options.text.day1 : (days < 5 ? this.options.text.day2 : this.options.text.day3)) + ' ';
				}
				time += hours + ':' + minutes + ':' + seconds;

				this.elements.time.innerHTML = time;
			}
		} else {
			if (this.elements.time && this.finishText) {
				this.elements.time.innerHTML = this.finishText;
			}
		}
	}

}

export class CountdownExtension {
	constructor(naja) {
		naja.addEventListener('init', () => {
			this.init(document);
		});

		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			this.init(event.snippet);
		});
	}

	init(block) {
		const countdowns = block.querySelectorAll('[data-countdown]');
		countdowns.forEach((countdownBlock) => {
			new Countdown(countdownBlock);
		});
	}
}